

export function baseUrl(path) {
    return `${this.$cursus.baseUrl ?? ''}${path}`;
}
